export const TpmOrderListFastFood = (showType = 'all') => {
    const OrderList = {
        "1628629200": {
            "2343": {
                "id":"2343",
                "products": [
                    {
                        "id": 2,
                        "id_category": 1,
                        "title": "Вкус Любви",
                        "price": "690",
                        "active": true,
                        "art": 1234,
                        "units": "шт.",
                        "discount": false,
                        "color": "#a0c3ff",
                        "description": "Филадельфия, Филадельфия MAX, Мажор, Шанхай, 32шт., 1,1кг.",
                        "count": 1
                    },
                    {
                        "id": 4,
                        "id_category": 1,
                        "title": "Филадельфия Микс",
                        "price": "699",
                        "active": true,
                        "art": 1234,
                        "units": "шт.",
                        "discount": false,
                        "color": "#52ff77",
                        "description": "филадельфия, филадельфия лайт, филадельфия MAX, 24 шт., 900 гр.",
                        "count": 1
                    }
                ],
                "orderData": {
                    "comment": "Это какое то примечание, к самому заказу",
                    "discountSale": 1,
                    "promokodeId": 0,
                    "sdacha": 200,
                    "typePayment": 0
                },
                "ItogSumOrder": 1250,
                "klient": {
                    "phone": "+79205952527",
                    "email": "uk091@yandex.ru",
                    "firstName": "Евгений",
                    "birthday": "1993-09-08T20:00:00.000Z",
                    "birthdayText": "1993-9-9",
                    "comment": "Примечание к самому клиенту, указанное в карточке",
                    "chanel": 2
                },
                "delivered": {
                    "pointOrderId": 1,
                    "timeDeliveredType": 0,
                    "typeDeliveredOrder": false,
                    "adres": {
                        "city": "Белгород",
                        "street": "Садовая",
                        "home": "59",
                        "entrance": 3,
                        "floor": 4,
                        "apartament": "45",
                        "comment": "Примечание к адресу доставки, указанное в получении"
                    },
                    "dateDeliveredText": "2021-11-6",
                    "dateDelivered": "2021-11-06T17:35:00.000Z",
                    "timeDeliveredText": "17:35",
                    "timeDelivered": "2021-11-06T17:35:16.208Z",
                    "dateSetOrder":"2021-11-06T17:35:00.000Z",
                },
                "marks": [
                    "Доставка",
                    "Гости",
                    "Заказ Оплачен"
                ],
                "memo":{
                    "typeSetOrder":{"text":"delivery club","color":"#2ecc71"},
                    "expiredStatus":1,
                },
                "ItogSumOrderNoDiscount": 1389,
                "sumDiscountOrder": 138
            },
            "866":{
                "id":"866",
                "products": [
                    {
                        "id": 3,
                        "id_category": 1,
                        "title": "Жара",
                        "price": "699",
                        "active": true,
                        "art": 1234,
                        "units": "шт.",
                        "discount": true,
                        "color": "#9fffe2",
                        "description": "Волк, Феникс, Фудзияма, 24шт., 1кг.",
                        "count": 1
                    },
                    {
                        "id": 19,
                        "id_category": 4,
                        "title": "Пикантная (Кайенская основа)",
                        "price": "370",
                        "active": true,
                        "art": 1234,
                        "units": "шт.",
                        "discount": false,
                        "color": "#ffeedd",
                        "description": "Описание товара",
                        "count": 1
                    },
                    {
                        "id": 20,
                        "id_category": 4,
                        "title": "Морская Премиум (Сливочная основа)",
                        "price": "499",
                        "active": true,
                        "art": 1234,
                        "units": "шт.",
                        "discount": false,
                        "color": "#ffeedd",
                        "description": "Описание товара",
                        "count": 1
                    }
                ],
                "orderData": {
                    "comment": "Примечание к заказу",
                    "discountSale": 0,
                    "promokodeId": 10,
                    "sdacha": 0,
                    "typePayment": 1
                },
                "ItogSumOrder": 1568,
                "klient": {
                    "phone": "+79511530614",
                    "email": "ildim@mail.ru",
                    "firstName": "Демьян",
                    "birthday": "1994-02-01T21:00:00.000Z",
                    "birthdayText": "1994-2-2",
                    "comment": "Примечание к клиенту, в заказе",
                    "chanel": 3
                },
                "delivered": {
                    "pointOrderId": 3,
                    "timeDeliveredType": 1,
                    "typeDeliveredOrder": true,
                    "dateDeliveredText": "2021-11-6",
                    "dateDelivered": "2021-11-06T16:51:00.000Z",
                    "timeDeliveredText": "21:55",
                    "timeDelivered": "2021-11-06T18:55:16.208Z",
                    "dateSetOrder":"2021-11-06T17:35:00.000Z",
                    "adres": false,
                },
                "marks": [
                    "Самовывоз",
                    "Все в разные контейнера"
                ],
                "memo":{
                    "typeSetOrder":{"text":"online","color":"#9b59b6"},
                    "expiredStatus":1,
                },
                "ItogSumOrderNoDiscount": 0, //Этих данных небыло - нужно посмотреть почему
                "sumDiscountOrder": 0 //этих тоже небыло
            }
        },"23445345678":
            {
                "12":
                    {
                        "id":"12",
                        "products": [
                            {
                                "id": 2,
                                "id_category": 1,
                                "title": "Вкус Любви",
                                "price": "690",
                                "active": true,
                                "art": 1234,
                                "units": "шт.",
                                "discount": false,
                                "color": "#a0c3ff",
                                "description": "Филадельфия, Филадельфия MAX, Мажор, Шанхай, 32шт., 1,1кг.",
                                "count": 1
                            },
                            {
                                "id": 9,
                                "id_category": 1,
                                "title": "Ред Фиш",
                                "price": "1499",
                                "active": true,
                                "art": 1234,
                                "units": "шт.",
                                "discount": false,
                                "color": "#ff5382",
                                "description": "Филадельфия МАХ, Волк, ролл Лосось, Мажор, Грейт Ролл, Сяке темпура, Немо, 54шт., 2кг.",
                                "count": 1
                            },
                            {
                                "id": 11,
                                "id_category": 2,
                                "title": "Пандора",
                                "price": "400",
                                "active": true,
                                "art": 1234,
                                "units": "шт.",
                                "discount": false,
                                "color": "#76bcff",
                                "description": "Рис, нори, японский майонез, огурец, тамаго, зеленый лук, тигровая креветка, масаго, лосось, 330гр.",
                                "count": 1
                            },
                            {
                                "id": 15,
                                "id_category": 3,
                                "title": "Суши Тигровая Креветка",
                                "price": "75",
                                "active": true,
                                "art": 1234,
                                "units": "шт.",
                                "discount": false,
                                "color": "#ffeedd",
                                "description": "42гр.",
                                "count": 1
                            },
                            {
                                "id": 20,
                                "id_category": 4,
                                "title": "Морская Премиум (Сливочная основа)",
                                "price": "499",
                                "active": true,
                                "art": 1234,
                                "units": "шт.",
                                "discount": false,
                                "color": "#ffeedd",
                                "description": "Описание товара",
                                "count": 1
                            },
                            {
                                "id": 25,
                                "id_category": 5,
                                "title": "Удон сливочный с креветкой и лососем",
                                "price": "320",
                                "active": true,
                                "art": 1234,
                                "units": "шт.",
                                "discount": false,
                                "color": "#ffeedd",
                                "description": "Пшеничная лапша, Тигровая креветка, Лосось, Овощная смесь (Лук репчатый, Кабачок, Брокколи, грибы Шампиньоны), Соевый соус, Сливочный соус, Кунжут, Зеленый лук, 370 гр.",
                                "count": 1
                            },
                            {
                                "id": 26,
                                "id_category": 6,
                                "title": "Мисо суп с окунем и кальмаром",
                                "price": "200",
                                "active": true,
                                "art": 1234,
                                "units": "шт.",
                                "discount": false,
                                "color": "#ffeedd",
                                "description": "Бульон Мисо, Кальмар командорский, Окунь, Вакаме, Сыр Тофу, Кунжут, Лук зеленый, 380 гр.",
                                "count": 1
                            },
                            {
                                "id": 29,
                                "id_category": 7,
                                "title": "Салат с Тигровой Креветкой",
                                "price": "230",
                                "active": true,
                                "art": 1234,
                                "units": "шт.",
                                "discount": false,
                                "color": "#ffeedd",
                                "description": "Салат листовой, креветка тигровая обжаренная, огурец, помидор, перец, соус горчичный, кунжут, 240гр.",
                                "count": 1
                            },
                            {
                                "id": 30,
                                "id_category": 8,
                                "title": "Мидии под сырным соусом (Бусидо)",
                                "price": "350",
                                "active": true,
                                "art": 1234,
                                "units": "шт.",
                                "discount": false,
                                "color": "#ffeedd",
                                "description": "Мидии Киви, Сырный соус (Майонез, Чеснок, Сыр, Масаго), 240 гр.",
                                "count": 1
                            }
                        ],
                        "orderData": {
                            "comment": "Ля ля ля, какое то примечание, оно большое, типа коммента от пользователя и тд, хаххаа",
                            "discountSale": 5,
                            "promokodeId": 0,
                            "sdacha": 0,
                            "typePayment": 1
                        },
                        "ItogSumOrder": 4063,
                        "klient": {
                            "phone": "+79205952527",
                            "email": "uk091@yandex.ru",
                            "firstName": "Евгений",
                            "birthday": "1993-09-08T20:00:00.000Z",
                            "birthdayText": "1993-9-9",
                            "comment": "Ну хз, короче какое то примечание ,",
                            "chanel": 1,
                            "personalDiscount": 2
                        },
                        "delivered": {
                            "pointOrderId": 4,
                            "timeDeliveredType": 0,
                            "typeDeliveredOrder": false,
                            //В создании заказа обязательно нужно дописать автоустановку времени получения dateDelivered

                            "dateDeliveredText": "2021-11-07",
                            "dateDelivered": "2021-11-07T10:43:00.000Z",
                            "timeDeliveredText": "10:43",
                            "timeDelivered": "2021-11-07T10:43:00.208Z", //Вот этой автоустановка нужна
                            "dateSetOrder":"2021-11-07T10:43:00.000Z", ////Так же автоустановку этой переменной

                            "adres": {
                                "city": "Белгород",
                                "street": "Богдана Хмельницкого",
                                "home": "112",
                                "entrance": 1,
                                "floor": 3,
                                "apartament": "9",
                                "comment": "Примечание к адресу пользователя, например что это его квартира и тд"
                            }
                        },
                        "marks": [
                            "Доставка",
                            "Безналичный расчет",
                            "Все в разные контейнера",
                            "Обязательно позвонить",
                            "Ожидание 1 час +- 20 мин."
                        ],
                        "ItogSumOrderNoDiscount": 4263,
                        "sumDiscountOrder": 200
                    }
            }
    };

    // console.log("Список в файле - ",OrderList);

    let newOrderList = setDisplayListOrder(OrderList,showType);

    return newOrderList;
};


export const TpmOrderListFastFood2 = (orderList) => {

    // console.log("То что передали ",orderList);

    let newOrderList = setDisplayListOrder(orderList,"all");

    return newOrderList;
};

export const setDisplayListOrder = (OrderList = {},typeShow = 'all')=> {
    // console.log('получили в список заказов в функцию setDisplayListOrder ',OrderList);
    let ii = 0;
    let bkColor = '';
    let DisplayListOrder = [];
    let numsPush = 1;

    // Перебираем все дни
    Object.keys(OrderList)
        .sort((a, b) => Number(b) - Number(a))
        .map(function(dateDays,ns){
        var StatusOrderOk = [];

        // Перебираем заказы в каждом дне
        let ordersForDay = Object.values(OrderList[dateDays]);

        // Сортируем заказы по времени создания в обратном порядке (сначала поздние заказы)
        ordersForDay.sort((a, b) => {
            const da = parseInt(a?.date_delivered || 0, 10);
            const db = parseInt(b?.date_delivered || 0, 10);
            if (db !== da) return db - da;
            return Number(b?.id || 0) - Number(a?.id || 0);
        });

        // Теперь можем пройтись по отсортированным заказам
        ordersForDay.map(function(order, number) {
            if(ii%2){
                bkColor = 'borderleftd';
            }else{
                bkColor = 'borderleftf';
            }

            // Добавляем заказ в список
            StatusOrderOk.push(order);
        });

        // Добавляем отсортированные заказы в общий список
        StatusOrderOk.map(function(order, nmO) {
            DisplayListOrder.push(order);
        });

        ii++;
    });

    if(DisplayListOrder.length <=0){
        console.log('Опа', DisplayListOrder.length, ' ', DisplayListOrder);
    }

    // console.log('Что выводим после сортировки',DisplayListOrder);

    return DisplayListOrder;
};


export const setDisplayListOrderDay = (OrderList)=> {
    let ii = 0;
    let bkColor = '';
    let DisplayListOrder = [];
    let numsPush = 1;
    Object.keys(OrderList).reverse().map(function(dateDays,ns){
        var StatusOrderOk = [];
        var StatusOrderNone = [];
        //console.log('Передаем массив:',OrderList[dateDays]);
        Object.keys(OrderList[dateDays]).map(function(data,number){
            StatusOrderOk.push({"date":new Date(dateDays*1000),"orders":OrderList[dateDays][data]});
        });


        StatusOrderNone.map(function(dats,nm){
                DisplayListOrder.push(dats);
            }
        );
        StatusOrderOk.map(function(datsO,nmO){
            DisplayListOrder.push(datsO);
        });

        ii++;
    });

    return DisplayListOrder;
};

//Проверка на соответствие условиям фильтра
const getCheckFilterOrder = (OrderData,FilterShowOrder = 'all')=>{
    let statusFilter = false;
    switch(FilterShowOrder){
        case "all": statusFilter = true;break;
        case "today":
            statusFilter = false;
            if(getDateCheked(OrderData.json.dilivery.dilivery_date,2) === true){
                statusFilter = true;
            }
            break;
        case "pickup":
            statusFilter = false;
            if(getStatusDeliveryOrder(OrderData.json.dilivery.dilivery_type) === false){
                statusFilter = true;
            }
            break;
        case "delivery":
            statusFilter = false;
            if(getStatusDeliveryOrder(OrderData.json.dilivery.dilivery_type) === true){
                statusFilter = true;
            }
            break;
        case "no_ready":
            statusFilter = false;
            if(OrderData.ready == "0"){
                statusFilter = true;
            }
            break;
        default:statusFilter = false;
    }
    return statusFilter;
}

const getStatusDeliveryOrder = (typeDelivery)=> {
    //console.log(typeDelivery);
    switch(typeDelivery){
        case 'Pickup':return false; break;
        case 'pickup': return false; break;
        case 'dilivery': return true; break;
        case 'Dilivery': return true; break;
        default: return false;
    }
};

const getDateCheked = (DateOrders, type = 1)=>{
    var nowDate = new Date();
    var nowDateText = nowDate.getDate()+'.'+nowDate.getMonth()+'.'+nowDate.getFullYear();
    var CurrentDate = new Date(nowDate.getTime() + 24 * 60 * 60 * 1000);
    var CurrentDateText = CurrentDate.getDate()+'.'+CurrentDate.getMonth()+'.'+CurrentDate.getFullYear();

    var OrderDate = new Date(DateOrders);
    var OrderDateText = OrderDate.getDate()+'.'+OrderDate.getMonth()+'.'+OrderDate.getFullYear();

    switch(type){
        case 1:
            if(OrderDateText == nowDateText || OrderDateText == CurrentDateText){
                return true;
            }else{
                return false;
            }
            break;
        default:
            if(OrderDateText == nowDateText){
                return true;
            }else{
                return false;
            }
    }

};

const getBackRed = (DateOrders,ComplateOrders)=>{
    let classTRDate = 'back_RED'


    let statusCheckDate = getDateCheked(DateOrders,1);

    //console.log(ComplateOrders);
    switch(ComplateOrders){
        case "0":
            if(statusCheckDate === true){
                classTRDate = 'back_RED';
            }else{
                classTRDate = '';
            }
            return classTRDate;
            break;
        default:
            return '';
    }
}

// export default TpmOrderList;
